import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import userReducer from "./slices/userSlice";
import searchPoliciesReducer from "./slices/searchPoliciesSlice";
import breadcrumbReducer from "./slices/breadcrumbSlice";
import getAgentReducer from "./agent/slices/getAgentSlice";
import ownerReducer from "./slices/ownerSlice";
import csrUserReducer from "./slices/csrUserSlice";
import alertsReducer from "./slices/getAlertsSlice";
import getAdminAlertsReducer from "./slices/getAdminAlertsSlice";

export const rootReducer = combineReducers({
  user: userReducer,
  data: searchPoliciesReducer,
  breadcrumbs: breadcrumbReducer,
  getAgent: getAgentReducer,
  owner: ownerReducer,
  csrUser: csrUserReducer,
  alerts: alertsReducer,
  csrAlerts: getAdminAlertsReducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
};

export const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// test util only
export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};
